const UserbackComponent = () => {

  let script = document.createElement('script');
  script.innerHTML = `
    Userback  = window.Userback || {};
    Userback.access_token = '2611|3841|AnCROeznwF1uXWviLmi70OMU43qZWJ9iuRyGQkikqRhYuuiX7v';

    (function(id) {
        if (document.getElementById(id)) {return;}
        var s = document.createElement('script');
        s.id = id;
        s.async = 1;
        s.src = 'https://static.userback.io/widget/v1.js';
        var parent_node = document.head || document.body;
        parent_node.appendChild(s);
    })('userback-sdk');
    `;

  document.body.appendChild(script);
  return null;
};

export default UserbackComponent;


// WEBPACK FOOTER //
// ./src/modules/commons/userback/Userback.component.tsx